export default __webpack_public_path__ + "static/media/hero-lpn.71cc6daa.png";